import { compose } from 'ramda';
import { selectors as subscriptions } from '../state/subscriptions';
import root from './root';

export default {
  list: compose(
    subscriptions.list,
    root.subscriptions,
  ),
};
